import { render, staticRenderFns } from "./EditRequestEndorsement.vue?vue&type=template&id=81359bda"
import script from "./EditRequestEndorsement.vue?vue&type=script&lang=js"
export * from "./EditRequestEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports